export default __webpack_public_path__ + "static/media/excavation2.52cac556.jpg";